import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import LayerAdminService from "../services/LayerAdminService";

const useLayerAdminService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new LayerAdminService(client);
  }, [client]);

  return service;
};

export default useLayerAdminService;
